module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-14.eb695b79.png";